import * as _4 from 'lodash4';
import { CourseSlot } from '../../../global/builders/ap_generic_slot_builder';
import { APTermServant } from '../../../global/servants/ap_term_servant';
export class ConflictReminderController {
  public term: any;
  public isPast: boolean;
  public credits: string;
  public buttonLabel: string;
  public coursesMissingRequisites: string[];
  public showConflictReminder: boolean;
  private coursesOffered: CourseSlot[];

  constructor(public $state: ng.ui.IStateService) {}
  initialize() {
    const termStatus = this.term._termStatus.value || this.term._termStatus;
    this.buttonLabel = termStatus.button_label || 'Pick Times';
    this.coursesMissingRequisites = APTermServant.coursesMissingRequisites(this.term);
    this.coursesOffered = this.term._genericSlots.filter(
      (course: CourseSlot) => course.plannedCourse && course.plannedCourse.is_course_offered === false
    );
  }
  $onInit() {
    this.initialize();
  }
  $onChanges() {
    this.initialize();
  }

  hide() {
    this.showConflictReminder = false;
  }
  continue() {
    this.hide();
    this.$state.go(
      'my.schedule.registration',
      {
        termId: this.term.id
      },
      { reload: true }
    );
  }
}

class ConflictReminder implements ng.IComponentOptions {
  public bindings: ng.IComponentOptions['bindings'];
  public controller: ng.IComponentOptions['controller'];
  public templateUrl: ng.IComponentOptions['templateUrl'];
  constructor() {
    this.bindings = {
      term: '<',
      showConflictReminder: '='
    };
    this.controller = ConflictReminderController;
    this.templateUrl =
      'capability-ng-academic-planner/src/plan/components/conflict_reminder_popup/conflict_reminder_popup.html';
  }
}
angular.module('capability-ng-academic-planner').component('conflictReminder', new ConflictReminder());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/conflict_reminder_popup/conflict_reminder_popup.ts